import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=1b68e701"
import script from "./AppPage.vue?vue&type=script&lang=ts"
export * from "./AppPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports